import { IValidationRule } from "@/types"

const collectiveReferenceNumbersRules: { [s: string]: IValidationRule } = {
    warehouseId: {
        required: true,
    },
    profitCenter: {
        required: true,
    },
    referenceNumberSale: {
        required: true,
    },
    referenceNumberRental: {
        required: true,
    },
}

export default collectiveReferenceNumbersRules
